import PrizePage from 'components/prizes/PrizePage';
import MainLayout from 'components/layout/MainLayout';
import { prizeApiClient } from 'utils/apiClient';
import { NextSeo } from 'next-seo';
import React, { useEffect } from 'react';
import { GetServerSideProps } from 'next/types';
import { PrizeV2 as Prize } from 'types/Prize';
import { MAIN_DRAW_SCHEDULE_NAME } from 'utils/constants';

interface IPrizePageForSlugProps {
  prize: Prize;
}

const PrizePageForSlug = ({ prize }: IPrizePageForSlugProps) => {
  let { seoMetaTitle, seoMetaDescription } = prize;

  if (!seoMetaTitle || seoMetaTitle.trim().length < 2) {
    seoMetaTitle = `${prize.title} - ${prize.subheading} | Win Epic Prizes | DAYMADE`;
  }

  if (!seoMetaDescription || seoMetaDescription.trim().length < 2) {
    seoMetaDescription =
      'Learn all about the EPIC DAYMADE prizes on offer here.';
  }

  useEffect(() => {
    prizeApiClient.public.incrementPrizeViewCount({
      body: {
        slug: prize.slug,
      },
    });
  }, []);

  return (
    <MainLayout limitItemWidths>
      {prize && (
        <NextSeo
          title={seoMetaTitle}
          description={seoMetaDescription}
          openGraph={{
            title: seoMetaTitle,
            description: seoMetaDescription,
            images: [
              {
                url: prize.imageLocations.main,
                alt: prize.seoImageAltText?.main,
              },
            ],
          }}
        />
      )}

      <PrizePage prize={prize} hideBackButton />
    </MainLayout>
  );
};

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const { slug } = ctx.query;
  let prize: Prize | null = null;

  const resp = await prizeApiClient.public.getPrizeBySlug({
    query: {
      slug: slug as string,
    },
  });

  switch (resp.status) {
    case 200:
      prize = {
        ...resp.body.prize,
        mainDrawWinningCriterion:
          resp.body.prize.winningCriteria[MAIN_DRAW_SCHEDULE_NAME] || null,
      };
      break;
    case 404:
      console.error(
        `Error fetching prize (slug: ${slug}): ${resp.body.message}`
      );
      return {
        notFound: true,
      };
  }

  ctx.res.setHeader(
    'Cache-Control',
    'public, max-age=3600, s-maxage=3600, stale-while-revalidate=59'
  );

  return {
    props: {
      prize,
    },
  };
};

export default PrizePageForSlug;
